import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-emerald-900 text-white py-10 sm:py-16 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="bg-emerald-800 rounded-2xl sm:rounded-3xl p-6 sm:p-12 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-20 sm:w-32 h-20 sm:h-32 bg-emerald-700 rounded-lg transform -rotate-12 -translate-x-6 sm:-translate-x-8 -translate-y-6 sm:-translate-y-8 opacity-50"></div>
          <div className="absolute bottom-0 right-0 w-24 sm:w-40 h-24 sm:h-40 bg-emerald-700 rounded-lg transform rotate-12 translate-x-8 sm:translate-x-12 translate-y-8 sm:translate-y-12 opacity-50"></div>

          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center space-x-2 sm:space-x-3 mb-3 sm:mb-4">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d0431b70-5f6b-41b3-bc61-e00e5d5a8fd8.png" 
                  alt="Desguace Gavá" 
                  className="h-10 sm:h-12 w-auto"
                />
                <span className="text-base sm:text-xl font-bold text-white">DESGUACE GAVÁ</span>
              </div>
              <p className="text-emerald-200 text-xs sm:text-sm leading-relaxed">
                Desguace profesional en Gavá. Compramos coches siniestrados, averiados y para chatarra. Recogida gratuita y pago inmediato.
              </p>
            </div>

            <div>
              <h4 className="text-white text-xs font-bold uppercase mb-3 sm:mb-4 tracking-wider">
                <a href="/servicios">SERVICIOS</a>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <Link to="/servicios" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    Coches Siniestrados
                  </Link>
                </li>
                <li>
                  <Link to="/servicios" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    Coches Averiados
                  </Link>
                </li>
                <li>
                  <Link to="/servicios" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    Retirada Gratuita
                  </Link>
                </li>
                <li>
                  <Link to="/servicios" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    Gestión Baja Tráfico
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/preguntas-frecuentes" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-xs font-bold uppercase mb-3 sm:mb-4 tracking-wider">
                <a href="/#zonas">ZONAS</a>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <span className="text-white text-xs sm:text-sm font-medium">Gavá (Principal)</span>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm">Castelldefels</span>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm">Viladecans</span>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm">Sant Boi</span>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm">El Prat</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-xs font-bold uppercase mb-3 sm:mb-4 tracking-wider">
                <a href="tel:+34932932913">CONTACTO</a>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a href="tel:+34932932913" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors flex items-center space-x-2">
                    <i className="ri-phone-fill"></i>
                    <span>932 932 913</span>
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/34932932913" target="_blank" rel="nofollow noopener noreferrer" className="text-emerald-200 text-xs sm:text-sm hover:text-white transition-colors flex items-center space-x-2">
                    <i className="ri-whatsapp-fill"></i>
                    <span>WhatsApp</span>
                  </a>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm flex items-center space-x-2">
                    <i className="ri-map-pin-fill"></i>
                    <span>Gavá, Barcelona</span>
                  </span>
                </li>
                <li>
                  <span className="text-emerald-200 text-xs sm:text-sm flex items-center space-x-2">
                    <i className="ri-time-fill"></i>
                    <span>L-V: 9-19h | S: 9-14h</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative border-t border-emerald-700 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="text-emerald-200 text-xs sm:text-sm text-center sm:text-left">
              <p>© 2025 Desguace Gavá. Todos los derechos reservados.</p>
            </div>
            <div className="flex items-center space-x-3">
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 sm:w-9 sm:h-9 bg-emerald-700 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white text-sm sm:text-base"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 sm:w-9 sm:h-9 bg-emerald-700 hover:bg-emerald-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-white text-sm sm:text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
